/* DSL Recent search history — store last 10 in localStorage, show below search input on focus */
(function(){
  var KEY = "dsl_search_history", MAX = 10;
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch(e){ return []; } }
  function add(q){
    if (!q || q.length < 2) return;
    var h = get().filter(function(x){ return x !== q; });
    h.unshift(q);
    try { localStorage.setItem(KEY, JSON.stringify(h.slice(0, MAX))); } catch(e){}
  }
  // Capture on form submit
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (f.action && f.action.indexOf("/search") !== -1) {
      var q = (f.querySelector("input[name=q]") || {}).value;
      if (q) add(q);
    }
  });
  // Show on focus
  document.addEventListener("focus", function(e){
    if (!e.target.matches("input[type=search][name=q]")) return;
    var inp = e.target;
    var hist = get();
    if (!hist.length || inp.dataset.histShown) return;
    var ul = document.createElement("ul");
    ul.className = "dsl-search-history";
    ul.innerHTML = "<li class=\"dsl-search-history__h\">Recent gezocht:</li>" + hist.map(function(q){ return "<li><a href=\"/search?q=" + encodeURIComponent(q) + "\">" + q + "</a></li>"; }).join("");
    inp.parentNode.appendChild(ul);
    inp.dataset.histShown = "1";
  }, true);
})();